

let _ = require('../_.js');
let $ = jQuery;


_.Page_Index = class Page_Index {

    static init() {
        _.AuctionUI_Router.on_navigate(
            _.Page_Index.on_navigate_match,
            _.Page_Index.on_hash_changed,
        );
    }

    // Called when SPA hash based navigation happens, return true if handling dispatch
    static on_navigate_match(hash) {
        if (hash == "" || hash.indexOf('item-') == 0) {
            return true;
        } else {
            return false;
        }
    }

    // Called on hash change, updates current item if the item exists
    static async on_hash_changed(hash) {
        if (hash.indexOf('item-') == 0) {
            let item_id = parseInt(hash.replace('item-', ''));
            let items = await _.ac_state.auction.auction_items.fetch();
            let found = false;
            for (let item of items) {
                if (item.id == item_id && _.ac_state.current_item_id != item_id) {
                    found = true;
                    _.AuctionUI.set_current_item(item_id);
                }
            }
            if (!found) {
                _.AuctionUI_Router.navigate_to("");
            }
        }
    }
}